import React, { memo, useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  makeGetNdataSnapshot,
  makeGetReceive3211,
} from '../../../../lib/selector';
import * as _ from 'lodash';
import {
  getColor10Gia,
  numberFormat,
  StringToDouble,
  StringToInt,
  _processMapData10,
} from '../../../../utils';
import { ndataSnapshotRequest } from '../../../../containers/banggia/actions';

// Hook
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

function Tbl10Buy(props) {
  const dispatch = useDispatch();

  const [idata, setIdata] = useState(null);
  const [ceilPrice, setCeilPrice] = useState('');
  const [refPrice, setRefPrice] = useState('');
  const [floorPrice, setFloorPrice] = useState('');
  const prevReceive3211 = usePrevious(props.receive3211);
  const prevNdataSnapshot = usePrevious(props.ndataSnapshot);

  //   useEffect(() => {
  //     const _receive3211 = _processMapData10({
  //       id: 3211.0,
  //       sym: 'VN30F2103',
  //       side: 'S',
  //       ndata:
  //         '1194.10:14SOH1194.30:1SOH1194.40:2SOH1194.50:1SOH1194.90:2SOH1196.80:1SOH1197:1SOH1199:2SOH1206:1SOH1213:4',
  //     });
  //     _process3211(_receive3211);
  //   }, []);

  useEffect(() => {
    if (
      props.ndataSnapshot &&
      props.ndataSnapshot.side === 'B' &&
      !_.isEqual(props.ndataSnapshot, prevNdataSnapshot)
    ) {
      const _receive3211 = _processMapData10(props.ndataSnapshot);
      _process3211(_receive3211);
    }
  }, [props.ndataSnapshot]);

  useEffect(() => {
    if (props.sym) {
      // get ndata snapshot
    dispatch(ndataSnapshotRequest(props.sym + ',B'));

      let _ceilPrice = document.getElementById(props.sym + 'ceil');
      let _refPrice = document.getElementById(props.sym + 'ref');
      let _floorPrice = document.getElementById(props.sym + 'floor');

      console.log(_ceilPrice)

      if (_ceilPrice) {
        const __ceilPrice = _ceilPrice.innerHTML;
        const __refPrice = _refPrice.innerHTML;
        const __floorPrice = _floorPrice.innerHTML;

        setCeilPrice(StringToDouble(__ceilPrice).toFixed(1));
        setRefPrice(StringToDouble(__refPrice).toFixed(1));
        setFloorPrice(StringToDouble(__floorPrice).toFixed(1));
      }
    }
  }, [props.sym]);

  useEffect(() => {
    if (
      props.receive3211 &&
      !_.isEqual(props.receive3211, prevReceive3211) &&
      props.receive3211.sym === props.sym &&
      props.receive3211.side === 'B'
    ) {
      const _receive3211 = _processMapData10(props.receive3211);
      _process3211(_receive3211);
    }
  }, [props.receive3211, props.sym]);

  const _process3211 = (data) => {
    setIdata(data);
  };

  return (
    <table className="table table-bordered w-100">
      <thead>
        <tr>
          <th colSpan="2" style={{ background: '#126712' }}>
            Bên mua
          </th>
        </tr>
        <tr>
          <th>Giá</th>
          <th style={{width: "40%"}}>KL</th>
        </tr>
      </thead>
      <tbody>
        {idata &&
          idata.data.map((el, idx) => {
            return (
              <tr
                key={idx}
                style={{
                  background: `-webkit-linear-gradient(right, #252d25 0px, #0f440f ${
                    (StringToInt(el[1]) * 100) / idata.totalVol
                  }%, transparent ${
                    (StringToInt(el[1]) * 100) / idata.totalVol
                  }%)`,
                }}
              >
                <td
                  className="text-right bg-transparent bb-1-haft"
                  style={{
                    color: `${getColor10Gia(
                      refPrice,
                      ceilPrice,
                      floorPrice,
                      el[0]
                    )}`,
                  }}
                >
                  {numberFormat(el[0], 1)}
                </td>
                <td className="text-right bg-transparent bb-1-haft">
                  {numberFormat(el[1])}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}

const makeMapStateToProps = () => {
  const getReceive3211 = makeGetReceive3211();
  const getNdataSnapshot = makeGetNdataSnapshot();

  const mapStateToProps = (state) => {
    return {
      receive3211: getReceive3211(state),
      ndataSnapshot: getNdataSnapshot(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(memo(Tbl10Buy));
